import { format, isToday, isYesterday } from 'date-fns';

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, 'MMM dd');
};

function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th'; // Covers 11th, 12th, 13th, etc.
  switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
  }
}

export const formatDate2 = (dateString) => {
const date = new Date(dateString);
const day = date.getDate();
const month = format(date, 'MMM');
const year = format(date, 'yyyy');
const ordinalSuffix = getOrdinalSuffix(day);

return `${day}${ordinalSuffix} ${month}, ${year}`;
};

export const formatDate3 = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDate4 = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now - date;
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (isToday(date)) {
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
  } else if (isYesterday(date)) {
    return '1 day ago';
  } else if (diffInDays <= 7) {
    return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
  } else {
    return format(date, 'dd/MM/yyyy');
  }
};

// utils/formatSlug.js
export const capitalizeSlug = (slug = '') =>
  slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');